module.exports = __webpack_public_path__ + "img/1-7.c88acb8e.png";